// import React, { useEffect, useState } from 'react';
// import Sidebar from '../components/Sidebar';
// import "./dashboard.css";
// import { Link, useSearchParams } from 'react-router-dom';
// import Navbar from '../components/Navbar';
// import { getregistrationbyevent } from '../store/slices/userSlice';
// import PaginatedTable from '../services/paginatedtable';
// import Swal from "sweetalert2";

// function Eventregistrationall() {
//   const [searchParams] = useSearchParams();
//   const eventId = searchParams.get("id") || "";
//   const [id, setId] = useState(null);
//   const [total, setTotal] = useState();
//   const [loading, setLoading] = useState(true);
//   const [data, setData] = useState([]);  // Initialize as empty array, not true
//   const [error, setError] = useState(null);
//   const [isModalOpen, setIsModalOpen] = useState(false); // <-- Added this line

//   const [selected, setSelected] = useState(null);

//   const fetchData = async () => {
//     setLoading(true);
//     setError(null);
//     try {
//       const response = await getregistrationbyevent(eventId);
//       setData(Array.isArray(response?.data) ? response.data : []);
//     } catch (err) {
//       Swal.fire('Error', 'Error getting data.', 'error');
//       setError('Error getting data.');
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     console.log('data',data)
//   }, [data]);

//   useEffect(() => {
//     fetchData();
//   }, []);

//   const handleEdit = (item) => {
//     setSelected(item);
//     window.location.href = `/viewregistration?id=${item.id}`;
//   };

//   return (
//     <div>
//       <Navbar />
//       <Sidebar />
//       {loading && (
//         <div className="preloader">
//           <div className="lds-ripple">
//             <div className="lds-pos"></div>
//             <div className="lds-pos"></div>
//           </div>
//         </div>
//       )}

//       <div id="main-wrapper">
//         <div className="page-wrapper d-block">
//           <div className="body-wrapper">
//             <div className="container-fluid">
//               <div className="folio-container"></div>
//               <div className="row">
//                 <div className="col-lg-12 d-flex align-items-stretch">
//                   <div className="card w-100">
//                   <div className="card-header" style={{ background: "#f06969" }}>
//                       <div className="d-sm-flex d-block align-items-center justify-content-between mb-4">
//                       <h4 className="card-title fw-semibold">Event Registrations</h4>
                       
//                       </div>
//                     </div>
                    
//                     <div className="card-body">
//                       <div className="d-sm-flex d-block align-items-center justify-content-between mb-4">
                
//                       </div>
//                       <div className="col-lg-12">
//                         {loading ? (
//                           <p>Loading...</p>
//                         ) : error ? (
//                           <p className="text-danger">Error: {error}</p>
//                         ) : data.length > 0 ? (
//                           <div className="table-responsive">
//                             <PaginatedTable
//                               columns={[
//                                 "id",
//                                 "name",
//                                 "phonenumber",
//                                 "email",
//                                 "startdate",
//                                 "enddate",
//                                 "package_name",
//                                 "adults",
//                                 "kids",
//                                 "rate",
//                                 "paymentstatus",
//                                 "orderid",
//                                 "transactionid",
//                                 "trackingid"
//                               ]}
//                               data={data}
//                               onEdit={handleEdit}
                              
//                             />
//                           </div>
//                         ) : (
//                           <p>No data available</p>
//                         )}
//                       </div>
//                     </div>
//                   </div>
                 
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default Eventregistrationall;


import React, { useEffect, useState } from 'react';
import Sidebar from '../components/Sidebar';
import "./dashboard.css";
import { Link, useSearchParams } from 'react-router-dom';
import Navbar from '../components/Navbar';
import { getregistrationbyevent, getregistrationbydate } from '../store/slices/userSlice';
import PaginatedTable from '../services/paginatedtable';
import Swal from "sweetalert2";

function Eventregistrationall() {
  const [searchParams] = useSearchParams();
  const eventId = searchParams.get("id") || "";
  const [id, setId] = useState(null);
  const [total, setTotal] = useState();
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  const [error, setError] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selected, setSelected] = useState(null);

  // New state variables for date filtering
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');

  const fetchData = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await getregistrationbyevent(eventId);
      setData(Array.isArray(response?.data) ? response.data : []);
    } catch (err) {
      Swal.fire('Error', 'Error getting data.', 'error');
      setError('Error getting data.');
    } finally {
      setLoading(false);
    }
  };

  // New function to fetch data by date range
  const fetchDataByDate = async () => {
    if (!startDate || !endDate) {
      Swal.fire('Warning', 'Please select both a start and end date.', 'warning');
      return;
    }

    setLoading(true);
    setError(null);
    try {
      // Assuming getregistrationbydate is a function that takes eventId, startDate, and endDate
      const response = await getregistrationbydate(eventId, startDate, endDate);
      setData(Array.isArray(response?.data) ? response.data : []);
    } catch (err) {
      Swal.fire('Error', 'Error getting data by date.', 'error');
      setError('Error getting data by date.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    console.log('data', data);
  }, [data]);

  useEffect(() => {
    fetchData();
  }, []);

  const handleEdit = (item) => {
    setSelected(item);
    window.location.href = `/viewregistration?id=${item.id}`;
  };

  return (
    <div>
      <Navbar />
      <Sidebar />
      {loading && (
        <div className="preloader">
          <div className="lds-ripple">
            <div className="lds-pos"></div>
            <div className="lds-pos"></div>
          </div>
        </div>
      )}

      <div id="main-wrapper">
        <div className="page-wrapper d-block">
          <div className="body-wrapper">
            <div className="container-fluid">
              <div className="folio-container"></div>
              <div className="row">
                <div className="col-lg-12 d-flex align-items-stretch">
                  <div className="card w-100">
                    <div className="card-header" style={{ background: "#f06969" }}>
                      <div className="d-sm-flex d-block align-items-center justify-content-between mb-4">
                        <h4 className="card-title fw-semibold">Event Registrations</h4>
                      </div>
                    </div>
                    
                    <div className="card-body">
                      {/* New Date Filtering Section */}
                      <div className="d-flex align-items-center mb-4">
                        <div className="me-3">
                          <label htmlFor="startDate" className="form-label">Start Date</label>
                          <input
                            type="date"
                            className="form-control"
                            id="startDate"
                            value={startDate}
                            onChange={(e) => setStartDate(e.target.value)}
                          />
                        </div>
                        <div className="me-3">
                          <label htmlFor="endDate" className="form-label">End Date</label>
                          <input
                            type="date"
                            className="form-control"
                            id="endDate"
                            value={endDate}
                            onChange={(e) => setEndDate(e.target.value)}
                          />
                        </div>
                        <div>
                          <button className="btn btn-primary mt-4" onClick={fetchDataByDate}>
                            Get Data
                          </button>
                        </div>
                      </div>

                      <div className="col-lg-12">
                        {loading ? (
                          <p>Loading...</p>
                        ) : error ? (
                          <p className="text-danger">Error: {error}</p>
                        ) : data.length > 0 ? (
                          <div className="table-responsive">
                            <PaginatedTable
                              columns={[
                                "id",
                                "name",
                                "phonenumber",
                                "email",
                                "startdate",
                                "enddate",
                                "package_name",
                                "adults",
                                "kids",
                                "rate",
                                "paymentstatus",
                                "orderid",
                                "transactionid",
                                "trackingid"
                              ]}
                              data={data}
                              onEdit={handleEdit}
                            />
                          </div>
                        ) : (
                          <p>No data available</p>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Eventregistrationall;